export interface ContactsBulkDeleteRequestModel {
  contactIds: number[];
}
